import type { DELETE } from 'src/consts';
import type { Action, ActionName } from 'src/types';

export enum Actions {
  UPDATE_LANGUAGE_START = 'UPDATE_LANGUAGE_START',
  UPDATE_LANGUAGE_SUCCESS = 'UPDATE_LANGUAGE_SUCCESS',
  UPDATE_LANGUAGE_FAILURE = 'UPDATE_LANGUAGE_FAILURE',

  REMOVE_LANGUAGE_START = 'REMOVE_LANGUAGE_START',
  REMOVE_LANGUAGE_SUCCESS = 'REMOVE_LANGUAGE_SUCCESS',
  REMOVE_LANGUAGE_FAILURE = 'REMOVE_LANGUAGE_FAILURE',
}

export type LanguageAction =
  | (Action<Actions.UPDATE_LANGUAGE_START> & {
      actionName: ActionName;
    })
  | Action<Actions.UPDATE_LANGUAGE_SUCCESS>
  | Action<Actions.UPDATE_LANGUAGE_FAILURE>
  | (Action<Actions.REMOVE_LANGUAGE_START> & {
      actionName: typeof DELETE;
    })
  | Action<Actions.REMOVE_LANGUAGE_FAILURE>
  | Action<Actions.REMOVE_LANGUAGE_SUCCESS>;
